export default __webpack_public_path__ + "static/media/cap-hill-pro.493123de.svg";